import React from 'react';
import { Tag } from 'antd';

const UserRoleTag = ({ role }) => {
  switch (role) {
    case 'super_admin':
      return <Tag color="red">SUPER ADMIN</Tag>; // Highlight super admin in red
    case 'admin':
      return <Tag color="purple">ADMIN</Tag>;
    case 'user':
    default:
      return <Tag color="blue">USER</Tag>;
  }
};

export default UserRoleTag;
